<template>
	<div class="setting-join-wesite">
		<div v-if="!editPage">
			<div class="module-item-style website-plugin">
				<div class="module-item-title">插件代码</div>
				<div class="module-item-tips">将此代码嵌入到你网站页面&lt;/body&gt;标签之前即可启用微聊客服，可以设置访客来源和指定客服，指定客服后你的网站将由指定的客服接待</div>
				<div style="line-height: 40px;margin-bottom: 10px;display: flex;">
					<span>设置访客来源标识：</span>
					<el-select v-model="source" placeholder="请选择" @change="setNewChatUrl">
						<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceQkCn" :value="item.sourceQk">
						</el-option>
					</el-select>
				</div>
				<div style="line-height: 40px;margin-bottom: 10px;">
					<el-checkbox v-model="setWebsiteService" @change="setWebsiteServiceId">指定客服</el-checkbox>
					<el-select v-model="toid" placeholder="请选择" v-if="setWebsiteService" style="margin-left: 46px;">
						<el-option v-for="item in serviceOptions" :key="item.csId" :label="item.csName" :value="item.csId">
						</el-option>
					</el-select>
				</div>
				<div class="code-wrap">
					<span class="code-copy" @click="copyText('pluginCode')">复制代码</span>
					<textarea readonly class="codePanel" id="pluginCode">
&lt;script type='text/javascript'&gt;
    (function (window, a, b) {
        window[a] = window[a] || function () {
            (window[a].a = window[a].a || []).push(arguments)
        };
        window[b] = window[b] || function () {
            (window[b].a = window[b].a || []).push(arguments)
        };
        var s = document.createElement("script");
        s.src = "{{jsApiUrl}}";
        s.async = true;
        s.charset = "UTF-8";
        document.getElementsByTagName("head")[0].appendChild(s);
    })(window, '_FENBOT', "_FENBOT_API");

    _FENBOT({cid: '{{companyId}}', type: '0', source: '{{source}}', toid: '{{toid}}'});
&lt;/script&gt;
                </textarea>
				</div>

				<div class="module-item-style website-plugin" style="padding: 0;">
					<div class="module-item-tips">在网站已经嵌入上面代码的情况下，将以下代码放入网站中任何需要使用客服的地方，通过示例中的方式可触发指定客服并标记访客咨询关键词</div>
					<div style="line-height: 40px;margin-bottom: 10px;">
						<el-checkbox v-model="setService" @change="setServiceId">指定客服</el-checkbox>
						<el-select v-model="setCsid" placeholder="请选择" v-if="setService" @change="setNewChatUrl" style="margin-left: 32px;width: 200px;">
							<el-option v-for="item in serviceOptions" :key="item.csId" :label="item.csName" :value="item.csId">
							</el-option>
						</el-select>
					</div>
					<div style="line-height: 40px;margin-bottom: 10px;display: flex;">
						<span>设置咨询关键词:</span>
						<el-input v-model="consult" style="width: 200px;margin-left: 10px;" placeholder="建议输入4-8个字的关键词"></el-input>
					</div>
					<div style="line-height: 40px;margin-bottom: 10px;display: flex;">
						<span>设置咨询语链接:</span>
						<el-input v-model="consultLink" style="width: 200px;margin-left: 10px;" placeholder="请输入咨询语链接"></el-input>
					</div>
					<div class="code-wrap">
						<span class="code-copy" @click="copyText('btnClickCode')">复制代码</span>
						<textarea readonly class="codePanel" style="height: 120px;" id="btnClickCode">
            var data = JSON.stringify({'csid': '{{setCsid}}','consult': '{{consult}}','consultLink':'{{consultLink}}'})
            sessionStorage.setItem('wlClickData', data)
            document.getElementById('CHAT-MODEL-BTN').click()
                </textarea>
					</div>


				</div>

				<div class="module-item-style website-plugin" style="padding: 0;">
					<div class="code-wrap" style="margin-top: 10px;">
						<textarea readonly class="codePanel" style="height: 320px;">
使用示例

// 通过下面按钮点击事件，打开微聊客服，此时咨询的客服是 cid 为 1 的客服，需要咨询的关键词是 「测试代码」

<button onclick="btnClick()">按钮</button>

function btnClick() {
    var data = JSON.stringify({'csid': '1','consult': '测试代码'})
    sessionStorage.setItem('wlClickData', data)
    document.getElementById('CHAT-MODEL-BTN').click()
}
                        </textarea>
					</div>


				</div>
			</div>


			<div class="module-item-style client-wrap">
				<div class="client-item">
					<div class="module-item-title">聊天链接</div>
					<textarea readonly class="visitor-url" id="pc">{{(selectId == '' || !designated) ? chatUrl : designatedUrl}}</textarea>
					<div style="line-height: 40px;margin-bottom: 10px;">
						<el-checkbox v-model="designated" @change="setNewService">指定客服分配</el-checkbox>
						<el-select class="ml20" v-model="selectId" placeholder="请选择" v-if="designated" @change="setNewChatUrl">
							<el-option v-for="item in serviceOptions" :key="item.csId" :label="item.csName" :value="item.csId">
							</el-option>
						</el-select>
					</div>
					<div>
						<span class="wl-btn" @click="copyText('pc')">复制</span>
					</div>
				</div>
				<div class="client-item" v-if="false" style="display: flex;">
					<div class="module-item-title">移动端</div>
					<textarea readonly class="visitor-url" id="mobile">{{visitorUrl}}/?cid={{companyId}}</textarea>
					<div>
						<span class="wl-btn" @click="copyText('mobile')">复制</span>
					</div>
				</div>
				<div class="client-item">
					<div class="module-item-title">二维码</div>
					<div class="qrcode">
						<img :src="QRCodePic" alt="">
					</div>
				</div>
			</div>

			<div class="module-item-style">
				<div class="module-item-title">PC端外观设置</div>
				<div class="module-item-tips">定制微聊插件外观，让它更契合你的网站</div>
				<div class="wl-btn" @click="toEidtPage('pc')">聊天按钮样式</div>
				<div class="module-item-title" style="margin-top: 15px;">聊天窗口显示位置</div>
				<div class="module-item-tips">默认值为你在「聊天按钮样式」中设置的位置</div>
				<div>
					<el-radio-group v-model="is_dialog_central" @change="saveConfig('is_dialog_central',is_dialog_central)">
						<el-radio :label="0">默认值</el-radio>
						<el-radio :label="1">屏幕中间</el-radio>
					</el-radio-group>
				</div>
				<div class="module-item-title" style="margin-top: 15px;">
					客服列表
					<el-switch style="margin-left: 20px;" v-model="is_open_cs_icon_menu" @change="saveChange('is_open_cs_icon_menu',is_open_cs_icon_menu)"
					 active-color="#68B974">
					</el-switch>
				</div>
				<div class="module-item-tips"> 默认关闭, 图标建议大小: 24*24</div>
				<div v-if="is_open_cs_icon_menu">
					<div class="wl-btn" @click="addIconMenu">新增</div>
					<el-table :data="serviceListData" style="width: 800px">
						<el-table-column label="列表图标" width="80">
							<template slot-scope="scope">
								<img style="display:inline-block;max-width: 24px;max-height: 24px;border-radius: 50%;" :src="scope.row.menuIconActive"
								 alt="">
							</template>
						</el-table-column>
						<el-table-column label="列表名称" prop="menuDesc">
						</el-table-column>
						<el-table-column label="指定客服">
							<template slot-scope="scope">
								{{ rendServiceName(scope.row.csId) }}
							</template>
						</el-table-column>
						<el-table-column label="咨询语" prop="consult">
						</el-table-column>
						<el-table-column label="操作" width="180">
							<template slot-scope="scope">
								<el-button size="mini" @click="handleEditServiceInfo( scope.row)">编辑
								</el-button>
								<el-button size="mini" type="danger" @click="handleDeleteServiceInfo( scope.row)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="module-item-style">
				<div class="module-item-title">移动端外观设置</div>
				<div class="module-item-tips">定制微聊插件外观，让它更契合你的网站</div>
				<div class="wl-btn" @click="toEidtPage('mob')">聊天按钮样式</div>
			</div>
			<div class="module-item-style upload-wechat" v-if="isQqAndWxAuth">
				<div class="module-item-title">微信联系方式（网页嵌入代码生效）</div>
				<div class="module-item-tips">上传微信二维码</div>

				<div class="qrcode-upload-container">
					<div class="upload-input">
						<div class="file-name-div">{{selectedWXCodeName}}</div>
						<input type="file" @change="wxPicChange" v-show="false" ref="wxPicInput">
						<div class="chose-file" @click="chooseWxCodePic">选择文件</div>
					</div>
					<div class="wl-btn" @click="uploadWxCodePic">
						上传
					</div>
				</div>
				<div class="qrcode" v-if="settingData.set_wx_qrcode_url.length > 0">
					<i class="el-icon-circle-close delWxPic" @click="delWxCodePic"></i>
					<img :src="settingData.set_wx_qrcode_url" alt="">
				</div>
			</div>

			<div class="module-item-style" v-if="isQqAndWxAuth">
				<div class="module-item-title">QQ联系方式（网页嵌入代码生效）</div>
				<div class="qq-input">
					<el-input v-model="settingData.set_qq_number" @change="changeQQ('set_qq_number')" placeholder="请输入内容"></el-input>
				</div>
			</div>
			<div class="module-item-style developer">
				<div class="module-item-title">开发者ID</div>
				<div class="dev-input-item">
					<div class="dev-input-item-label">APPID(应用ID)：</div>
					<el-input readonly class="dev-input-item-input" v-model="APPConfig.appid" placeholder="请输入内容"></el-input>
				</div>
				<div class="dev-input-item">
					<div class="dev-input-item-label">APP SECRET：</div>
					<el-input v-if="hidePwd" readonly type="password" class="dev-input-item-input" v-model="APPConfig.appserct"
					 placeholder="请输入内容"></el-input>
					<el-input v-else readonly type="text" class="dev-input-item-input" v-model="APPConfig.appserct" placeholder="请输入内容"></el-input>
					<span class="show-hide-pwd" @click="pwdVisibleChange">{{pwdVisibleChangeTxt}}</span>
				</div>
			</div>

			<div class="module-item-style">
				<div class="module-item-title">微信安全验证设置</div>
				<div class="module-item-tips">微聊对话框嵌入公众号菜单时，需要将 chat.weiliaokefu.com 设置为微信业务域名。</div>
				<div class="wl-btn" v-if="false">操作步骤</div>
			</div>
			<div class="module-item-style upload-wechat">
				<div class="module-item-title">上传微信验证文件</div>
				<div class="qrcode-upload-container">
					<div class="upload-input">
						<div class="file-name-div">{{selectedWXFileName}}</div>
						<input type="file" @change="wxConfigFileChange" v-show="false" ref="wxConfigFileInput">
						<div class="chose-file" @click="chooseWxConfigFile">选择文件</div>
					</div>
					<div class="wl-btn" @click="uploadWxCongFile">
						上传
					</div>
				</div>
				<div class="wxfile-box">
					<tableMulti :tableData="tableData" :tableHead="tableHead" :tableHandler="tableHandler" :total="total" :size="pageSize"
					 @handleButton="handleOperate" @pageHandler="pageOperate"></tableMulti>
				</div>
			</div>
		</div>

		<transition name="fade-transform" mode="out-in">
			<router-view v-if="editPage" />
		</transition>
		<el-dialog :title="dialogServiceListTitle" :visible.sync="dialogServiceListVisible" class="dialogService" width="500px"
		 :before-close="handleDialogClose">
			<el-form ref="dialogServiceListForm" :model="dialogServiceListForm" :rules="rules" label-width="80px">
				<el-form-item label="列表图标" prop="menuIconActive">
					<div class="adPicItem">
						<el-input class="picInput" v-model="dialogServiceListForm.menuIconActive" placeholder="粘贴图片地址或上传图片"></el-input>
						<span class="choosePic" @click="choosePic">选择图片</span>
					</div>
					<input type="file" ref="chooseAdPic" @change="uploadAdImage" v-show="false" />
				</el-form-item>
				<el-form-item label="列表名称" prop="menuDesc">
					<el-input v-model="dialogServiceListForm.menuDesc"></el-input>
				</el-form-item>
				<el-form-item label="指定客服">
					<el-select v-model="dialogServiceListForm.csId" clearable placeholder="选择客服">
						<el-option v-for="(item, index) in serviceOptions" :label="item.csName" :value="item.csId" :key="'sl-'+index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="咨询语">
					<el-input v-model="dialogServiceListForm.consult"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleDialogClose">取 消</el-button>
				<el-button type="primary" @click="saveServiceList('dialogServiceListForm')">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import tableMulti from '@/components/table/table-multi'

	export default {
		name: 'setting-join-wesite',
		components: {
			tableMulti
		},
		data() {
			return {
				is_dialog_central: 0,
				webCode: '',
				hidePwd: true,
				pwdVisibleChangeTxt: '显示密钥',
				QRCodePic: '',
				selectedWXCodeName: '',
				uploadWxPicData: null,
				uploadWxFileData: null,
				selectedWXFileName: '',
				accept: 'image/gif, image/jpeg, image/png, image/jpg',
				// jsApiUrl: process.env.VUE_APP_API_URL+'/wlapi/js/jsFileStr',
				jsApiUrl: process.env.VUE_APP_JSAPI + '/Public/dist/js/jsapi.js',
				visitorUrl: process.env.VUE_APP_VISITOR_URL,
				isQqAndWxAuth: false,
				settingData: {
					set_wx_qrcode_url: '',
					set_qq_number: ''
				},
				currentPage: 1,
				pageSize: 10,
				tableHandler: [{
					label: "删除",
					type: 'del',
					methods: 'delMethods'
				}, ],
				tableData: [{}],
				tableHead: [{
					label: '名称',
					value: 'name',
					operate: false
				}, {
					label: '操作',
					value: '',
					width: '160',
					operate: true,
				}],
				total: 0,
				APPConfig: '',
				designated: false,
				serviceOptions: [],
				selectId: '',
				designatedUrl: '',
				serviceListData: [],
				dialogServiceListVisible: false,
				dialogServiceListTitle: '新增',
				dialogServiceListType: 'add',
				dialogServiceListForm: {
					csId: '',
					menuIconActive: '',
					menuDesc: '',
					consult: '',
				},
				rules: {
					menuIconActive: [{
						required: true,
						message: "图片不能为空",
						trigger: "blur"
					}],
					menuDesc: [{
						required: true,
						message: "名称不能为空",
						trigger: "blur"
					}],
				},
				is_open_cs_icon_menu: false,
				setCsid: '',
				consult: '',
				consultLink: '',
				setWebsiteService: false,
				setService: false,
				source: '',
				toid: '',
				sourceList: []
			}
		},
		computed: {
			chatUrl() {
				let id = this.$store.state.user.userInfo.companyId
				let url = `${this.visitorUrl}/?cid=${id}&alone=1`
				this.getChatQRCode(url)
				return url
			},
			companyId() {
				return this.$store.state.user.userInfo.companyId
			},
			editPage() {
				let route = this.$route
				if (route.name == 'settingJoinWebsite') {
					return false
				} else {
					return true
				}
			},
		},
		created() {
			this.getQQAndWxConfig()
			this.getAPPConfig()
			this.joinGetWXConfigFile()
			this.getAllService()
			this.getIconMenuList()
			this.getVisitorSourceQk()
		},
		mounted() {

		},
		methods: {
			// 访客来源标识列表
			getVisitorSourceQk() {
				this.$http.getVisitorSourceQkAPI().then(res => {
					if (res.status == 1) {
						this.sourceList = res.data
					}
					console.log('source-list=', res)
				})
			},
			// 插件代码-指定客服
			setWebsiteServiceId() {
				this.toid = ''
			},
			setServiceId() {
				this.setCsid = ''
			},
			saveChange(name, value) {
				let postValue;
				if (value == '') {
					postValue = ''
				} else {
					if (value == 'true' || value == true) {
						postValue = 1
					} else if (value == 'false' || value == false) {
						postValue = 0
					} else {
						postValue = value
					}
				}
				this.$http.saveConfigAPI({
					name,
					value: postValue
				}).then(res => {
					if (res.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
						})
						this.getQQAndQRCode()
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			// 新增列表
			addIconMenu() {
				this.dialogServiceListTitle = '新增'
				this.dialogServiceListType = 'add'
				this.dialogServiceListVisible = true
			},
			choosePic() {
				this.$refs.chooseAdPic.click()
			},
			uploadAdImage(e) {
				let img = e.target.files[0];
				let type = img.type;
				let size = img.size;
				if (this.accept.indexOf(type) == -1) {
					this.$message({
						showClose: true,
						message: "图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg",
						type: "error",
						duration: 3 * 1000
					});
					return false;
				}
				if (size > 5242880) {
					this.$message({
						showClose: true,
						message: "请选择5M以内的图片！",
						type: "error",
						duration: 3 * 1000
					});
					return false;
				}
				let formdata = new FormData();
				formdata.set("file", img);
				this.$http.uploadImageAPI(formdata).then(res => {
					if (res.status == 1) {
						this.dialogServiceListForm.menuIconActive = res.data;
					}
				});
			},
			// 会话框关闭
			handleDialogClose() {
				this.dialogServiceListVisible = false
				this.dialogServiceListForm = {
					csId: '',
					menuIconActive: '',
					menuDesc: '',
					consult: '',
				}
			},
			// 根据客服id渲染客服名称
			rendServiceName(value) {
				let csName = ''
				this.serviceOptions.map((item) => {
					if (item.csId == value) {
						csName = item.csName
					}
				})
				return csName
			},
			// 获取客服列表信息
			getIconMenuList() {
				this.$http.getIconMenuListAPI().then(res => {
					if (res.status == 1) {
						this.serviceListData = res.data
					}
				})
			},
			/**
			 * 编辑客服图标信息
			 * */
			handleEditServiceInfo(item) {
				this.dialogServiceListTitle = '编辑'
				this.dialogServiceListType = 'edit'
				this.dialogServiceListVisible = true
				this.dialogServiceListForm = {
					iconMenuId: item.id,
					csId: item.csId,
					menuIconActive: item.menuIconActive,
					menuDesc: item.menuDesc,
					consult: item.consult,
				}
			},
			/**
			 * 删除客服图标信息
			 * */
			handleDeleteServiceInfo(item) {
				this.$confirm('你正在进行删除操作，此操作不可恢复, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delIconMenuAPI({
						iconMenuId: item.id
					}).then(res => {
						if (res.status == 1) {
							this.$message({
								message: res.msg,
								type: 'success',
							})
							this.getIconMenuList()
							this.handleDialogClose()
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							})
						}
					})
				}).catch(() => {

				});

			},
			// 保存列表信息
			saveServiceList(formName) {
				this.dialogServiceListForm.consult = this.dialogServiceListForm.consult.replace(/<.*?>/g, "")
				this.dialogServiceListForm.menuDesc = this.dialogServiceListForm.menuDesc.replace(/<.*?>/g, "")
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.dialogServiceListType === "add") {
							this.$http.addIconMenuAPI(this.dialogServiceListForm).then(res => {
								if (res.status == 1) {
									this.getIconMenuList()
									this.handleDialogClose()
									this.$message({
										message: res.msg,
										type: 'success',
									})
								} else {
									this.$message({
										message: res.msg,
										type: 'error',
									})
								}
							})
						} else if (this.dialogServiceListType === "edit") {
							this.$http.editIconMenuAPI(this.dialogServiceListForm).then(res => {
								if (res.status == 1) {
									this.getIconMenuList()
									this.handleDialogClose()
									this.$message({
										message: res.msg,
										type: 'success',
									})
								} else {
									this.$message({
										message: res.msg,
										type: 'error',
									})
								}
							})
						}
					} else {
						return false;
					}
				});
			},
			saveConfig(name, value) {
				this.$http.saveConfigAPI({
					name,
					value: value,
				}).then(res => {
					if (res.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
						})
						this.getQQAndQRCode()
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			getChatQRCode(data) {
				this.$http.changeChatQRCOdeAPI({
					param: data
				}).then(res => {

					this.QRCodePic = URL.createObjectURL(res)
					// console.log('res==', res)
				})
			},
			setNewService() {
				this.selectId = ''
				this.designatedUrl = ''
				if (!this.designated) {
					this.getChatQRCode(this.chatUrl)
				}
			},
			setNewChatUrl() {
				this.designatedUrl = this.chatUrl + '&toid=' + this.selectId
				this.getChatQRCode(this.designatedUrl)
			},
			/**
			 * 获取角色列表
			 */
			getAllService() {
				let postParams = {
					pageNum: 1,
					pageSize: 50,
					name: '',
					type: ''
				}
				this.isLoading = true
				this.$http.getServiceListAPI(postParams).then(res => {
					if (res.status == 1) {
						this.serviceOptions = res.data.csList
					}
					this.isLoading = false
				}).catch(err => {
					this.isLoading = false
				})
			},
			/**
			 * 表单操作
			 * @param val
			 */
			handleOperate(val) {

				let delData = []
				if (val.methods == "delMethods") {
					// let dotIndex = val.row.name.lastIndexOf(".");
					// let fileName = val.row.name.substr(0, dotIndex);
					delData.push(val.row.name)
				} else if (val.methods == 'delAll') {
					if (val.row.length == 0) {
						this.$message({
							showClose: true,
							message: '请勾选要删除的二维码名片',
							type: 'error',
							duration: 3 * 1000
						})
						return false
					}
					val.row.map((item) => {
						// let dotIndex = item.name.lastIndexOf(".");
						// let fileName = item.name.substr(0, dotIndex);
						delData.push(item.name)
					})
				}
				this.delWxFile(delData)
			},
			/**
			 *  分页操作
			 * @param val
			 */
			pageOperate(val) {
				if (val.type == 'currentChange') {
					this.currentPage = val.val
				} else if (val.type == "sizeChange") {
					this.pageSize = val.val
				}
				// this.getFileList()
			},
			/**
			 * 复制
			 * @param id
			 */
			copyText(id) {
				let text = document.getElementById(id);
				text.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.$message({
					message: '复制成功',
					type: 'success',
				})
			},
			getQQAndWxConfig() {
				this.$http.joinGetQQAndQRCodeConfigAPI().then(res => {
					if (res.status == 1) {
						this.isQqAndWxAuth = res.data.isQqAndWxAuth
						if (res.data.isQqAndWxAuth) {
							this.getQQAndQRCode()
						}
					}
				})
			},
			/**
			 * 按钮编辑跳转
			 * */
			toEidtPage(val) {
				if (val == 'pc') {
					this.$router.push({
						path: '/setting-join-website-pc'
					})
				} else if (val == 'mob') {
					this.$router.push({
						path: '/setting-join-website-mob'
					})
				}
			},
			/**
			 * 获取设置的QQ和微信二维码
			 */
			getQQAndQRCode() {
				this.$http.joinGetQRcodeAndQQAPI().then(res => {
					if (res.status == 1) {
						this.settingData = res.data
						if (res.data.is_dialog_central) {
							this.is_dialog_central = Number(res.data.is_dialog_central)
						} else {
							this.is_dialog_central = 0
						}
						if (res.data.is_open_cs_icon_menu == '1') {
							this.is_open_cs_icon_menu = true
						} else {
							this.is_open_cs_icon_menu = false
						}

					}
				})
			},
			/**
			 * 保存QQ修改
			 * @param name
			 */
			changeQQ(name) {
				this.$http.saveConfigAPI({
					name,
					value: this.settingData.set_qq_number
				}).then(res => {
					if (res.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success',
						})
						this.getQQAndQRCode()
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			chooseWxCodePic() {
				this.$refs.wxPicInput.click()
			},
			wxPicChange(e) {
				let img = e.target.files[0]
				let type = img.type
				let size = img.size
				if (this.accept.indexOf(type) == -1) {
					this.$message({
						showClose: true,
						message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
						type: 'error',
						duration: 3 * 1000
					})
					return false
				}
				if (size > 5242880) {
					this.$message({
						showClose: true,
						message: '请选择5M以内的图片！',
						type: 'error',
						duration: 3 * 1000
					})
					return false
				}
				this.selectedWXCodeName = img.name
				this.uploadWxPicData = img
			},
			/**
			 * 上传微信二维码
			 * @returns {boolean}
			 */
			uploadWxCodePic() {
				if (!this.selectedWXCodeName) {
					this.$message({
						showClose: true,
						message: '请先选择要上传的二维码！',
						type: 'error',
						duration: 3 * 1000
					})
					return false
				}
				let formdata = new FormData()
				formdata.set('file', this.uploadWxPicData)

				this.$http.joinUploadQRcodeAPI(formdata).then(res => {
					if (res.status == 1) {
						this.getQQAndQRCode()
						this.$refs.wxPicInput.value = ''
						this.selectedWXCodeName = ''
						this.$message({
							message: res.msg,
							type: 'success',
						})
					}
				}).catch(error => {
					this.$message({
						message: '二维码名片上传失败，请重试！',
						type: 'error',
					})
				})
			},
			delWxCodePic() {
				this.$http.joinDelQRcodeAPI().then(res => {
					if (res.status == 1) {
						this.getQQAndQRCode()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			getAPPConfig() {
				this.$http.joinGetAPPConfigAPI().then(res => {
					if (res.status == 1) {
						this.APPConfig = res.data
					}
				})
			},
			/**
			 * 密钥显示-隐藏
			 */
			pwdVisibleChange() {
				this.hidePwd = !this.hidePwd
				this.pwdVisibleChangeTxt = this.hidePwd ? '显示密钥' : '隐藏密钥'
			},
			/**
			 * 获取已上传的微信文件
			 */
			joinGetWXConfigFile() {
				this.$http.joinGetWXConfigListAPI().then(res => {
					if (res.status == 1) {
						let data = res.data
						let newaData = []
						data.map(item => {
							let obj = {}
							obj.name = item
							newaData.push(obj)
						})
						this.tableData = newaData
					}
				})
			},
			chooseWxConfigFile() {
				this.$refs.wxConfigFileInput.click()
			},
			wxConfigFileChange(e) {
				let file = e.target.files[0]
				this.selectedWXFileName = file.name
				this.uploadWxFileData = file
			},
			uploadWxCongFile() {
				if (!this.uploadWxFileData) {
					this.$message({
						message: '请选择要上传的文件',
						type: 'error'
					})
					return false
				}
				let formdata = new FormData()
				formdata.set('file', this.uploadWxFileData)
				this.$http.joinUploadWXConfigFileAPI(formdata).then(res => {
					if (res.status == 1) {
						this.joinGetWXConfigFile()
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			delWxFile(data) {
				this.$http.joinDelWXConfigFileAPI({
					fileNames: data
				}).then(res => {
					if (res.status == 1) {
						this.joinGetWXConfigFile()
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			}

		}
	}
</script>

<style lang="scss">
	
</style>
